import { IModalMethods, IModalEntity } from "./interface";
import { modalEntity } from "./entity";

export default <IModalMethods> {

	setModal(v: IModalEntity) {
		modalEntity.modalState = v
	},

}